import * as AppleAuthentication from 'expo-apple-authentication'
import { useRouter } from 'solito/router'

import AppleSvg from 'app/assets/icons/auth/apple-icon.svg'
import Button from 'app/components/base/Button'
import ErrorHandler, { isErrorHandlerType } from 'app/services/ErrorHandler'
import { useAppleAuthorizeMutation } from 'app/services/Query/user/user.mutation'
import useAuthStore, { getAuthActions } from 'app/store/auth.store'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'
import { generateAgentToken } from 'app/utils/helpers/functions.helpers'
import { isOfType } from 'app/utils/helpers/type.helpers'

interface AppleButtonProps {
  variant: 'register' | 'login'
  onSuccess?: () => void
}

const AppleButton: RFC<AppleButtonProps> = ({ variant = 'login' }) => {
  const { push } = useRouter()
  const actions = useAuthStore(getAuthActions)

  const appleLogin = useAppleAuthorizeMutation()

  const handleSuccess = async () => {
    try {
      const credential = await AppleAuthentication.signInAsync({
        requestedScopes: [
          AppleAuthentication.AppleAuthenticationScope.FULL_NAME,
          AppleAuthentication.AppleAuthenticationScope.EMAIL
        ]
      })

      const { familyName, givenName } = credential?.fullName || {}
      const agentToken = generateAgentToken()

      const resp = await appleLogin.mutateAsync({
        user: {
          access_token: credential?.identityToken || '',
          first_name: givenName || '',
          last_name: familyName || '',
          keep_me_logged_in: true
        },
        agent_token: agentToken,
        action_type: variant
      })

      await actions.authorize(resp.jwt_token)

      push('/search')
    } catch (error) {
      if (
        !!error &&
        isOfType.object(error) &&
        'code' in error &&
        error?.code === 'ERR_CANCELED'
      ) {
        // handle that the user canceled the sign-in flow
      } else {
        if (isErrorHandlerType(error)) new ErrorHandler(error?.data)
      }
    }
  }

  return (
    <Button
      variant="outlined"
      sx={{ flex: 1 }}
      onClick={handleSuccess}
      {...(IS_NATIVE_APP && { labelSx: { height: 18 } })}
    >
      <AppleSvg />
    </Button>
  )
}

export default AppleButton
